// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"268":"leads","779":"error"}[chunkId] + "." + {"268":"63ddd49f","779":"c77b824a"}[chunkId] + ".js";
};